///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable, NgZone } from '@angular/core';

@Injectable()
export class GtthAccessDeniedModalService {
    private _isOpen = false;
    private showTimer;
    private readonly showTimeout = 5000;
    private _message: string;

    constructor(private readonly ngZone: NgZone) {}

    get isOpen(): boolean {
        return this._isOpen;
    }

    get message(): string {
        return this._message;
    }

    set message(value: string) {
        this._message = value;
    }

    open(message?: string) {
        if (this._isOpen) {
            return;
        }
        if (message && message !== '') {
            this._message = message;
        }
        this._isOpen = true;
        this.ngZone.runOutsideAngular(() => {
            this.showTimer = setTimeout(() => {
                this.ngZone.run(() => {
                    this.close();
                });
            }, this.showTimeout);
        });
    }

    close() {
        if (this.showTimer) {
            clearTimeout(this.showTimer);
        }
        this._isOpen = false;
        this._message = undefined;
    }
}
